// extracted by mini-css-extract-plugin
export var deleteModal = "_s5-0";